'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ru_RU = require('../../date-picker/locale/ru_RU');

var _ru_RU2 = _interopRequireDefault(_ru_RU);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _ru_RU2["default"];
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./components/calendar/locale/ru_RU.tsx
 ** module id = 758
 ** module chunks = 1
 **/